import * as Yup from "yup"
import { AvailableLanguages } from "../types"

export const languageField: Yup.Schema<AvailableLanguages> =
  Yup.mixed<AvailableLanguages>().oneOf(Object.values(AvailableLanguages))
